// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NotFound-root__L3Zlc {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 18px;\n}\n", "",{"version":3,"sources":["webpack://./../ui/pages/__not-found/NotFound.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;AACjB","sourcesContent":[".root {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "NotFound-root__L3Zlc"
};
export default ___CSS_LOADER_EXPORT___;
